// extracted by mini-css-extract-plugin
export default {"main":"ObXUdqvr2O_T59WnYfIP","input":"JOQ3xKe3o2PATB3sIlSl","fix":"AOy9_spDwFfaJ1KyoXaO","areaCode":"rS7A0MEjX5QYCuc8DBRj","common_bganimation":"bzzCDWtFJsMMA847m3Ag"};